import {
	clearCurrentTree,
	clearRehabTreesDefault,
	getRehabTreesList,
	setInitalLoadSet,
} from '@Actions';
import { selectIsLoading } from '@Selectors';
import { FullPage, FullPageWrapper } from '@Utils/styles';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import AGSList from '@Components/AGSetList';
import { useGlobalization } from '@Translations';

const AGSets = () => {
	const { t } = useGlobalization();
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(clearCurrentTree());
		dispatch(clearRehabTreesDefault());
		dispatch(getRehabTreesList());
		dispatch(setInitalLoadSet(true));
	}, []);

	const isLoading = selectIsLoading();

	return (
		<FullPageWrapper
			isLoading={isLoading}
			title={t('Asset Group Sets')}
			applyPadding={true}
			headerUnderline>
			<FullPage>
				<AGSList />
			</FullPage>
		</FullPageWrapper>
	);
};
export default AGSets;
